import BaseTextField from "../../../../components/ui/BaseTextField";
import { useDispatch, useSelector } from "react-redux";
import {
  updateWorkOrderForm,
  updateWorkOrderFormValidation,
} from "../../../../store/workOrder/workOrderSlice";

const FullDayPay = ({ disabled = false }) => {
  const dispatch = useDispatch();
  const payment = useSelector((state) => state.workOrder.payment.pay);
  const workOrderFormValidation = useSelector(
    (state) => state.workOrder.workOrderFormValidation
  );

  const handleChange = (event) => {
    const { name, value } = event.target;
    const parsedValue = parseFloat(value);
    dispatch(
      updateWorkOrderForm({
        step: "payment",
        data: {
          pay: {
            [name]: value,
          },
        },
      })
    );
    if (name === "fullDayRate" && parsedValue > 0) {
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "fullDayRate",
          data: false,
        })
      );
    }
    if (name === "fullDayRate" && (!value || parsedValue <= 0)) {
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "fullDayRate",
          data: true,
        })
      );
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "fullDayRateErrorMsg",
          data: "Full Day Rate is required",
        })
      );
    }
  };

  return (
    <div className="grid grid-cols-2 gap-y-4 mt-4">
      <div className="mr-10">
        <BaseTextField
          disabled={disabled}
          onInput={(e) => (e.target.value = e.target.value.replace(/-/g, ""))}
          error={workOrderFormValidation.fullDayRate}
          errorMsg={workOrderFormValidation.fullDayRateErrorMsg}
          fullWidth
          fullHeight={false}
          id="fullDayRate"
          name="fullDayRate"
          label="Full Day Rate"
          requirement="required"
          labelShrink={false}
          value={payment.fullDayRate}
          onChange={handleChange}
          type="float"
          isDefaultField={false}
        />
      </div>
      <div>
        <BaseTextField
          disabled={disabled}
          onInput={(e) => (e.target.value = e.target.value.replace(/-/g, ""))}
          error={workOrderFormValidation.hourlyRate}
          errorMsg={workOrderFormValidation.hourlyRateErrorMsg}
          fullWidth
          fullHeight={false}
          id="hourlyRate"
          name="hourlyRate"
          label="Additional Hour Rate"
          requirement="required"
          labelShrink={false}
          value={payment.hourlyRate}
          onChange={handleChange}
          isDefaultField={false}
          type="float"
        />
        <p className="mt-2 text-sm text-right">
          Additional hourly rate will be applicable after 8 hours of Work
        </p>
      </div>
    </div>
  );
};

export default FullDayPay;
